import { render, staticRenderFns } from "./projectView.vue?vue&type=template&id=47f96d7f&scoped=true&"
import script from "./projectView.vue?vue&type=script&lang=js&"
export * from "./projectView.vue?vue&type=script&lang=js&"
import style0 from "./projectView.vue?vue&type=style&index=0&id=47f96d7f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f96d7f",
  null
  
)

export default component.exports